import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC } from "react";
import { CollaboratorServicesSummary } from "src/apis/company";
import { formatDateToBR } from "src/utils/date";

type ServicesByColaboratorSummaryTableProps = {
  startDate: string;
  endDate: string;
  summary: CollaboratorServicesSummary|null;
}

const ServicesByColaboratorSummaryTable: FC<ServicesByColaboratorSummaryTableProps> = ({startDate, endDate, summary}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableCell colSpan={2}><strong>Resumo de atendimentos, período de {formatDateToBR(startDate)} até {formatDateToBR(endDate)}</strong></TableCell>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell><strong>Colaborador</strong></TableCell>
            <TableCell>{summary?.nome_colaborador}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Atendimentos</strong></TableCell>
            <TableCell>{summary?.qtde_atendimentos}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Primeiro atendimento</strong></TableCell>
            <TableCell>{formatDateToBR(summary?.primeiro_atendimento)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Último atendimento</strong></TableCell>
            <TableCell>{formatDateToBR(summary?.ultimo_atendimento)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Atendido por</strong></TableCell>
            <TableCell>
              {summary?.psicologos?.map((nomePsicologo) => (
                <p>{nomePsicologo}</p>
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ServicesByColaboratorSummaryTable;
